import { User } from '@cxc/react-universal-components';

declare global {
  interface Window {
    env: {
      FPFC_AEM_BASE_URL?: string;
      USER?: User;
      REACT_APP_ENV?: string;
    };
  }
}

const FPFC_PROJECT_SCOPE = 'FPFC';

const paths = {
  customerTools: '/customer-tools',
  fpt: '/fordpro-service-tools/api/v1',
  fpgBff: '/fpg-bff',
  fpgProxy: '/proxy-api-request',
  fpgUnauthProxy: '/proxy-api-request-unauth',
};

export interface EnvironmentSpecificUrl {
  dev: string;
  local: string;
  prod: string;
  stage: string;
  test: string;
}

export const FPFC_BACKEND_URL: EnvironmentSpecificUrl = {
  prod: `https://api.pd01i.gcp.ford.com/pro${paths.customerTools}`,
  stage: `https://api.stg01i.gcp.ford.com/pro${paths.customerTools}`,
  dev: `https://api.d01i.gcp.ford.com/pro${paths.customerTools}`,
  local: `http://localhost:8080${paths.customerTools}`,
  test: `https://api.example.com${paths.customerTools}`,
};

export const FPG_BFF_URL: EnvironmentSpecificUrl = {
  prod: `https://${window.location.hostname}`,
  stage: `https://${window.location.hostname}`,
  dev: `https://${window.location.hostname}`,
  local: `http://localhost:3000`,
  test: `https://fpg.example.com`,
};

export const FPT_BACKEND_URL: EnvironmentSpecificUrl = {
  prod: `https://api-prd.fordpro.com/pro${paths.fpt}`,
  stage: `https://api-stg.fordpro.com/pro${paths.fpt}`,
  dev: `https://api-dev.fordpro.com/pro${paths.fpt}`,
  local: `http://localhost:8082${paths.fpt}`,
  test: `https://api.example.com${paths.fpt}`,
};

export const AEM_BASE_URL: EnvironmentSpecificUrl = {
  prod: `https://content.fordpro.com`,
  stage: `https://contentqa.fordpro.com`,
  dev: `https://contentqa.fordpro.com`,
  local: `https://contentqa.fordpro.com`,
  test: `https://contentqa.example.com`,
};

const getEnvSpecificUrl = (envSpecificUrl: EnvironmentSpecificUrl) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-explicit-any
  switch ((window as any)?.env.REACT_APP_ENV) {
    case 'development':
      return envSpecificUrl.dev;
    case 'stage':
      return envSpecificUrl.stage;
    case 'prod':
      console.log('prod = ' + envSpecificUrl.prod);
      return envSpecificUrl.prod;
    case 'local':
      return envSpecificUrl.local;
    case 'unit-test':
      return envSpecificUrl.test;
    default:
      throw new Error('Invalid environment set for window.env.REACT_APP_ENV');
  }
};

const fpfcBackendUrl = getEnvSpecificUrl(FPFC_BACKEND_URL);

const fptBackendUrl = getEnvSpecificUrl(FPT_BACKEND_URL);

const fpgBffUrl = getEnvSpecificUrl(FPG_BFF_URL);

const aemBaseUrl = getEnvSpecificUrl(AEM_BASE_URL);

const properties = {
  AemBaseUrl: aemBaseUrl,

  FpfcBackendUrl: fpfcBackendUrl,

  FptBackendUrl: fptBackendUrl,

  FpgBffUrl: fpgBffUrl,

  Paths: paths,

  FpfcProjectScope: FPFC_PROJECT_SCOPE,
};

export default properties;
